/* eslint-disable */
import axios from "axios"
import axiosRetry from "axios-retry"
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

function replaceDomain(url, newDomain) {
  let replacedUrl = url;
  if (replacedUrl.startsWith('//')) {
    replacedUrl = replacedUrl.replace(/^(\/\/[^\/\n]+)/i, '//' + newDomain);
  } else if (replacedUrl.startsWith('https://')) {
    replacedUrl = replacedUrl.replace(/^https?:\/\/([^\/\n]+)/i, 'https://' + newDomain);
  } else if (replacedUrl.startsWith('http://')) {
    replacedUrl = replacedUrl.replace(/^https?:\/\/([^\/\n]+)/i, 'http://' + newDomain);
  }
  return replacedUrl;
}

export default function(options) {
  const client = axios.create(options)

  client.interceptors.request.use((config) => {
    config.url = replaceDomain(config.url, process.env.VUE_APP_SECURE_DOMAIN)
    config.headers.appcode = "promotion"
    return config
  }, err => Promise.reject(error))

  axiosRetry(client, {
    retryCondition(error) {
      return error.code === "ECONNABORTED" // Retry timed out requests
    },
  })
  return client
}
